// croppie.service.ts
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CroppieService {
  private croppiePromise: Promise<any> | null = null;
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  load() {
    if (!this.isBrowser) {
      return Promise.reject('Croppie is only available in the browser');
    }

    if (!this.croppiePromise) {
      this.croppiePromise = import('croppie').then(m => m.default);
    }
    return this.croppiePromise;
  }
}